// Suppress XState predictableActionArguments warning from Sanity dependencies
// This warning comes from Sanity's internal XState usage and cannot be fixed by us

const originalWarn = console.warn;
console.warn = function(...args) {
  // Check if this is the XState predictableActionArguments warning
  const message = args.join(' ');
  if (message.includes('It is highly recommended to set `predictableActionArguments` to `true` when using `createMachine`')) {
    // Suppress this specific warning as it's from Sanity's dependencies
    return;
  }
  // Allow all other warnings through
  originalWarn.apply(console, args);
};
